export default __webpack_public_path__ + "static/brain-2685e804cde1fe06b36138836eb06908.svg";